const axios = require('axios');
const HttpRequest = require('./http-request');

const DEFAULT_GET_USER_SETTINGS_PATH = '/api/userSettings';
const DEFAULT_METHOD = 'get';

// One hour
const CACHE_TTL_MILLIS = 60 * 60 * 1000;

/**
 * Client for EAS interaction, specifically fetching entity object.
 */
class UserSettings {
  constructor(authProvider, endpoint) {
    // For now assume endpoint is static - allow to change per-request if customers want.
    this.authProvider = authProvider;
    this.endpoint = endpoint;
    this.userSettingsCache = {};
  }

  async _fetchUserSettingsObject(userId) {
    // Create a skeleton http request for EAS.
    const httpReq = new HttpRequest();
    httpReq.headers['Content-Type'] = '';
    httpReq.url = this.endpoint + DEFAULT_GET_USER_SETTINGS_PATH; // Q: Split into separate endpoint and path props?
    httpReq.method = DEFAULT_METHOD;

    // Delegate modifications to the auth provider.
    // TODO: Handle various exception cases from interface docs.
    await this.authProvider.injectAuth(httpReq);

    // Execute the http request using axios.
    const axiosParams = {
      method: httpReq.method,
      headers: httpReq.headers,
    };

    if (httpReq.body) {
      if (method === 'post' || method === 'patch' || method === 'put') {
        axiosParams.data = httpReq.body;
      } else {
        axiosParams.params = httpReq.body;
      }
    }

    if (
      !this.userSettingsCache[userId] ||
      this._cacheIsExpired(this.userSettingsCache[userId].refreshTime)
    ) {
      const userSettings = (await axios.request(httpReq.url, axiosParams)).data;
      this.userSettingsCache[userId] = {
        settings: userSettings,
        refreshTime: +new Date(),
      };
    }

    return this.userSettingsCache[userId].settings;
  }

  _cacheIsExpired(refreshTime) {
    return +new Date() - refreshTime > CACHE_TTL_MILLIS;
  }

  async userIsCKS(userId) {
    const userSettings = await this._fetchUserSettingsObject(userId);
    const validUserSettings = userSettings && userSettings.length;
    return validUserSettings && userSettings[0].orgPublicKey;
  }
}

module.exports = UserSettings;
